export default "__VITE_ASSET__B6JMog6Q__"